import React from 'react'
import lImage from './Images/LMS_login.png';
import sImage from './Images/snake.jpg';
import tImage from './Images/TFA.png'
import rImage from './Images/RMS.png'
import { wrap } from 'framer-motion';
import '@splidejs/splide/dist/css/splide.min.css';
// or
import '@splidejs/splide/dist/css/themes/splide-skyblue.min.css';
import { Splide, SplideSlide } from '@splidejs/react-splide';

// import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

const splide = new Splide( '.splide', {
  type   : 'loop',
  drag   : 'free',
  focus  : 'center',
  perPage: 3,
  autoScroll: {
    speed: 1,
  },
} );


export default function Project() {
  return (
    <div  className='pMain'>
      <div id="Project" className='ProjectTitile'>
      <br/> Projects
      </div>        
      <br/>
      <Splide options={ {
    type         : 'loop',
    gap          : '1rem',
    perPage: 3,
    autoplay     : true,
    pauseOnHover : false,
    resetProgress: false,
    height       : '45rem',
    width        : '80rem'
  } } aria-label="React Splide Example">
      <SplideSlide>

      <div className='pCard'>
                <h4>Library Management System</h4>
                
                <div>
                <a href='https://github.com/adityaraj152002/Library-Management-System' target='blank'> <img style={{height:220,width:350,borderRadius:30}} src={lImage}/></a>
                </div>
                
                <div>
                  A Library Management System (LMS) automates library tasks, manages resources, and enhances services. It stores book information, handles cataloging, circulation, and acquisitions. LMS maintains member records, facilitates book issuance, and offers online services like reservations and renewals. With a user-friendly interface, it streamlines library operations, improves resource accessibility, and provides better services to users.
                </div>
                {/* <br/> */}
        </div>
      </SplideSlide>
      <SplideSlide>
      <div className='pCard'>
                <h4>Classic Snake Game</h4>
                <div>
                  
                <a href='https://github.com/adityaraj152002/Classic-Snake-Game' target='blank'><img style={{width: 350, height: 220,borderRadius:30}} src={sImage}/></a> 
                </div>
                
                <div>
                <p>Snake, a beloved arcade-style game, emerged in the late 1970s and gained popularity in the 1990s. Players control a snake on the screen, consuming dots as food while avoiding walls and self-collision. With each food intake, the snake grows longer, intensifying the challenge. Directional changes are made using arrow keys or controls. This addictive game tests reflexes and strategy within a confined space, making Snake an enduring classic in the realm of video games.</p> 
                </div>                
            </div>
      </SplideSlide>
      <SplideSlide>
      <div className='pCard'>
                <h5 >Restaurant Management System </h5>
                <div>
                   
                <a href='https://github.com/adityaraj152002/Restaurant_Management_System_using_LinkedList' target='blank'><img style={{width: 350, height: 220,borderRadius:30}} src={rImage}/></a> 
                </div>
               
                <div>
                <p>A linked list-based restaurant management system streamlines operations by efficiently organizing orders, menu items, customer details, and reservations. With dynamic memory allocation, it enables easy additions and deletions, enhancing efficiency and customer service. This system simplifies tracking and optimizes daily activities, ensuring a seamless dining experience and effective management of restaurant tasks.</p> 
                </div>                
            </div>
      </SplideSlide>
 
      <SplideSlide>
      <div className='pCard'> 
            <h4>Three Factor Authentication</h4>
            
            <div>
                <img style={{width:350,height:220,borderRadius:30}} src={tImage }/>
            </div>
            
            <div>
              <p>Three-factor authentication (3FA) adds an extra layer of security to traditional two-factor authentication. It combines something the user knows, possesses, and is, such as a password, physical token, and biometric data. By requiring multiple factors for authentication, 3FA significantly reduces the risk of unauthorized access. Despite potential complexities, it is increasingly adopted in sectors like banking and healthcare for robust protection against cyber threats.</p>
            </div> 
        </div>
      </SplideSlide>
    </Splide>
        
    </div>
  )
}
